import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeasurementGridToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10.25,
			stroke: "currentColor",
			strokeWidth: 1.3,
			opacity: .55
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 7.5,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 7.5,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 7.5,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 12,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 12,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 16.5,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 16.5,
			r: 1.35,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 16.5,
			r: 1.35,
			fill: "currentColor"
		})
	]
});
export default SvgMeasurementGridToolbar;
